// extracted by mini-css-extract-plugin
export default {"details":"Results_details__-a5IF","block":"Results_block__oO9YZ","job":"Results_job__DXYf-","row":"Results_row__FNmXh"};